<template>
  <div class="ExpertViewPopups">
    <el-dialog
      :visible.sync="authBypassVerifyUserPopup"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="plan-subscription-notification-dialog"
    >
      <div>
        <div class="logos">
          <div style="position: relative; top: -10px;">
            <div class="powered-by-txt">Powered by</div>
            <img
              src="../assets/images/logo/logo1.png"
              alt="StockAnts"
              class="logo"
            />
          </div>
          <div class="center-line"></div>
          <div v-if="currentEnvironment">
            <img
              :src="currentEnvironment.logo"
              :alt="currentEnvironment.utm_source"
              class="logo"
              :style="[
                currentEnvironment.width
                  ? { width: currentEnvironment.width }
                  : {},
              ]"
              style=" padding: 0 10px ;"
            />
          </div>
        </div>

        <div class="flex main-section">
          <div class="left-img">
            <img src="../assets/images/authBypassOpenDematImage.png" alt="" />
          </div>
          <div class="right-content">
            <h3>Open Demat Account With Ashlar India</h3>

            <el-button
              class="btn-theme-filled"
              style="width: 100%; margin: 10px auto; padding: 10px 15px;"
               @click="goToDematLink('https://kyc.wisdomcapital.in/')"
              >Open Now</el-button
            >

            <p>Already having Demat Account</p>

            <div class="flex">
              <el-input
                placeholder="Enter Customer ID"
                v-model="customer_id"
                size="mini"
                style="width:70%; border-radius: 7px"
              >
              </el-input>

              <el-button
                class="verify-btn"
                size="mini"
                style="margin-left: 10px; width: 25%;"
                @click="verifyCustomerId"
              >
                Verify
              </el-button>
            </div>
          </div>
        </div>

        <div
          class="font-08rem font-weight-500 cursor-pointer text-center top-margin-15"
          style="text-decoration: underline; color: #2488fe;"
          @click="authBypassVerifyUserPopup = false"
        >
          Skip for now
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { serverAddr, serverHostName } from "../networkConfig";
import CripNotice from "crip-vue-notice";
import { updateProfileNetworkCallBack } from "../mixins/UpdateProfile.NetworkCallBack";

export default {
  name: "ExpertViewPopups",
  props: ["kyc_confirmation_popup"],
  mixins: [],

  data() {
    return {
      authBypassVerifyUserPopup: false,
      currentEnvironment: localStorage.getItem("currentEnvironment")
        ? JSON.parse(localStorage.getItem("currentEnvironment"))
        : {},

      // kyc_check: false,
      // aadhar_card_number: null,
      // pan_card_number: null,
      // email: "",
      // is_otp_sent: false,
      customer_id: null,
    };
  },

  mounted() {
    // this.authBypassVerifyUserPopup = this.ShowDematcustIdPopup;
  },

  validations: {},

  watch: {},
  methods: {
    verifyCustomerId() {
      if (this.customer_id) {
        serverAddr
          .post("/auth/v1/partial_profile_update", {
            broker_client_id: this.customer_id,
          })
          .then((response) => {
            // Handle successful response
          })
          .catch((error) => {
            // Handle error response
            console.error("Error verifying Customer ID:", error);
          });
      } else {
        // Handle case when customer_id is empty
        console.error("Customer ID is required");
      }
    },
    
    goToDematLink(link) {
      window.open(link, "_blank");
    },
  },
  computed: {
    ShowDematcustIdPopup() {
      return this.currentEnvironment && this.currentEnvironment.byPassLogin;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.ExpertViewPopups {
  .plan-subscription-notification-dialog {
    .logos {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .logo {
      width: 190px;
      height: auto;
    }
    .powered-by-txt {
      text-align: left;
      font-weight: 700;
      position: relative;
      left: 10px;
      font-size: 12px;
      color: #0e0e0e;
    }
    .center-line {
      border: 1px solid rgb(130, 129, 129);
      height: 45px;
      align-self: center;
    }

    .main-section {
      align-items: flex-start;

      h3 {
        color: #0e0e0e;
        margin: 0;
        text-align: left;
      }
      .left-img {
        border-right: 1px solid gray;
        padding-right: 20px;
        img {
          width: 100%;
        }
      }
      .right-content {
        padding-left: 20px;

        p {
          font-weight: 600;
          text-align: left;
        }
        .verify-btn {
          // border: 1px solid #2488fe;
          color: #2488fe;
          border-radius: 4px;
          cursor: pointer;
          background: #e9f3ff;
          border-color: #e9f3ff;
          padding: 7px 10px;
        }

        .verify-btn:hover {
          color: #fff;
          background-color: #2488fe;
          transition-delay: 0.2s;
        }
      }
    }
  }
}
@media screen and (max-width: 660px) {
  .ExpertViewPopups {
    .plan-subscription-notification-dialog {
      .logos {
        .logo {
          //  width: 50%;
        }
      }
      .main-section {
        flex-direction: column;
        align-items: center;

        h3 {
          margin-top: 20px;
        }
        .left-img {
          border-right: none;
        }
      }
    }
  }
}
@media screen and (max-width: 444px) {
  .ExpertViewPopups {
    .plan-subscription-notification-dialog {
      .logos {
        .logo {
          width: 100% !important;
        }
      }
    }
    .kyc_dialog .content-section .btn-secondary-theme-filled {
      margin-left: 0 !important;
    }
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";
.ExpertViewPopups {
  .kyc_dialog {
    .el-input__inner {
      border: 1px solid #d3d1d1;
    }
    .user-box-width {
      width: 180px;
    }
    .el-collapse-item__header .el-collapse-item__arrow {
      display: block !important;
    }
    .el-dialog {
      width: 650px;
      border-radius: 8px;
      margin-top: 25px !important;
    }
    .el-dialog__body {
      border-radius: 8px;
      color: #000;
      background-color: #f0f7ff;
    }
    .el-dialog__body,
    .el-dialog__header {
      padding: 0;
    }
    .img-section {
      border-radius: 8px;
      padding: 0px 10px;
      border-radius: 8px 0 0 8px;
      // height: 400px;
    }
    .content-section {
      border-radius: 0 8px 8px 0;
      padding: 20px;
      background-color: #ffff;
      min-height: 380px;
      h3 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-top: 0px;
      }
    }

    // .el-collapse-item {
    //   background-color: #f0f7ff !important;
    //   border-bottom: none !important;
    //   margin: 20px 0;
    //   padding: 15px;
    //   border-radius: 8px;
    // }
    // .el-collapse-item__header.is-active {
    //   color: #2d2e8d;
    // }
    // .el-collapse-item__header {
    //   font-weight: 600;
    //   color: #9c9d9f;
    // }

    .detail-box {
      border: 1px solid #d3d1d1;
      border-radius: 4px;
      padding: 5px;
      font-size: 12px;
      color: #000;
      margin-top: 3px;
      line-height: 18px;
    }
  }

  .plan-subscription-notification-dialog {
    .el-dialog {
      border-radius: 10px;
      width: 650px;
    }
    .el-dialog__body {
      word-break: normal !important;
    }
    .el-dialog__header {
      padding: 0px;
    }

    .el-input--mini .el-input__inner {
      background: #f9f9f9;
    }
    input::placeholder {
      color: #4c4a4a;
      font-size: 10px;
    }
  }
}

@media screen and (max-width: 660px) {
  .ExpertViewPopups {
    .plan-subscription-notification-dialog {
      .el-dialog {
        margin-top: 40px;
        width: 90%;
        text-align: center;
      }
    }
    .kyc_dialog .el-dialog {
      width: 95% !important ;
    }
    .kyc_dialog .content-section {
      width: 94% !important;
    }
  }
}

@media screen and (max-width: 550px) {
  .ExpertViewPopups {
    .kyc_dialog .content-section {
      border-radius: 8px;
      padding: 20px;

      .el-radio__label {
        white-space: normal;
        word-wrap: break-word;
        max-width: 320px;
      }
    }
  }
}
</style>

